import React,{useState,useRef} from 'react';
import { Header ,Modal} from '../../../../components';
import { Button, message, Input, BackTop, DatePicker } from 'antd';
import { useStateContext } from '../../../../contexts/ContextProvider';
import { useModal } from 'react-modal-hook';
import  Table  from '../components/Table';
import  Form  from '../components/Form';
import { useFetchEmployeesTimeline,UseFetchUpdateEmployeesTimeline} from "../hooks/useFetch";
import dayjs from 'dayjs';

function EmployeesTimeline() {
  const { currentColor } = useStateContext();
  const [ dataEdit, setDataEdit] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(dayjs());
  const monthParam = selectedMonth ? selectedMonth.format('YYYY-MM') : undefined;
  const { data:dataEmployees, isLoading:isLoadingEmployees ,refetch:refetchEmployees } = useFetchEmployeesTimeline(monthParam);
  const {  mutate: fetchUpdateEmployeesTimeline } = UseFetchUpdateEmployeesTimeline();

  const titlePage = 'ประวัติการเข้างาน';
  const formAddRef = useRef(null); 
  const formEditRef = useRef(null); 
  
  //#region usehook model
  const [showAddModal, hideAddModal] = useModal(() => {
    const handleOnOk = async (event) => {
      event.preventDefault();
      message.loading('กรุณารอซักครู่...', 0);
      try {
        const value =  await formAddRef.current.validateFields();
        const payload = {
          ...value,
          companyId: sessionStorage.getItem('activeCompanyId')
        }
        
        // TODO: FETCH API
        var result = await fetchUpdateEmployeesTimeline(payload)
        await message.destroy(); 
        await message.success('เพิ่มข้อมูลสำเร็จ');
        await hideAddModal();
        refetchEmployees()
      } catch (error) {
        console.error('Error adding data:', error);
        message.error('ไม่สามารถเพิ่มข้อมูลได้'); 
        //await hideAddModal();
      } finally {
        await message.destroy(); 
        
      }
    };

    return (
      <Modal
        title={`เพิ่ม ${titlePage}`}
        okText='ยืนยัน'
        cancelText='ยกเลิก'
        width={600}
        onOk={handleOnOk}
        onCancel={hideAddModal}
      >
        <Form formRef={formAddRef}/>
      </Modal>
    );
  }, []);

  const [showEditModal, hideEditModal] = useModal(() => {
    const handleOnOk = async (event) => {
      event.preventDefault();
      message.loading('กรุณารอซักครู่...', 0);
      try {
        const value =  await formEditRef.current.validateFields();
        const payload = {
          ...value,
          companyId: sessionStorage.getItem('activeCompanyId'),
          id: dataEdit.id
        }

        let result = await fetchUpdateEmployeesTimeline(payload)

        await message.destroy(); 
        await message.success('แก้ไขขอมูลสำเร็จ');
        await hideEditModal();
        refetchEmployees()
      } catch (error) {
        console.error('Error adding data:', error);
        message.error('ไม่สามารถแก้ไขข้อมูลได้'); 
        //await hideAddModal();
      } finally {
        await message.destroy(); 
      }
    };

    return (
      <Modal
        title={`แก้ไข ${titlePage}`}
        okText='ยืนยัน'
        cancelText='ยกเลิก'
        width={600}
        onOk={handleOnOk}
        onCancel={hideEditModal}
      >
        <Form formRef={formEditRef} initialValues={dataEdit}/>
      </Modal>
    );
  }, [dataEdit,isLoadingEmployees]);
    //#endregion


  const handleEdit = (record) => {
     setDataEdit(record);
     showEditModal()
  }

  const handleDelete = async (record) => {
    try {
      //isLoadingEmployees(true)
      // await deleteEmployeesTimeline(record.id)
      await message.destroy(); 
      await message.success('ลบสำเร็จ',2);
      refetchEmployees()
    } catch (error) {
      message.error('ไม่สามารถลบได้'); 
    } finally {
      await message.destroy(); 
      await hideEditModal();
    }
  }

  return (
    <div className="md:m-10">
      <div className="flex justify-between">
        <Header category="App" title={titlePage} />
        <div className="flex items-center gap-3">
          <DatePicker picker="month" placeholder="เลือกเดือน" onChange={(value) => {setSelectedMonth(value); setTimeout(() => {refetchEmployees()}, 500)}} allowClear defaultValue={dayjs()} />
          {/* <Button onClick={showAddModal} className='bg-blue-500 text-white'>
            เพิ่ม
          </Button> */}
        </div>
      </div>
      <Table data={dataEmployees} onEdit={handleEdit} onDelete={handleDelete}  loading={isLoadingEmployees} dataBank={dataEmployees} bordered />
    </div>
  );
}

export default EmployeesTimeline;
